export const MATRIX_MAX_EVENT_BYTES = 65536;

const EVENT_ENVELOPE_OVERHEAD_BYTES = 2048;

const ENCRYPTED_CIPHERTEXT_FIELDS_OVERHEAD_BYTES = 1024;

const textEncoder = new TextEncoder();

export const getUtf8ByteLength = (value: string): number => textEncoder.encode(value).length;

export const getContentByteSize = (content: unknown): number => getUtf8ByteLength(JSON.stringify(content));

export const estimateSendSizeBytes = (content: unknown, isEncrypted: boolean): number => {
    const plainBytes = getContentByteSize(content);
    if (!isEncrypted) return plainBytes + EVENT_ENVELOPE_OVERHEAD_BYTES;
    return Math.ceil((plainBytes * 4) / 3) + ENCRYPTED_CIPHERTEXT_FIELDS_OVERHEAD_BYTES + EVENT_ENVELOPE_OVERHEAD_BYTES;
};

export const isContentTooLargeToSend = (content: unknown, isEncrypted: boolean): boolean =>
    estimateSendSizeBytes(content, isEncrypted) > MATRIX_MAX_EVENT_BYTES;

export const bytesToKB = (bytes: number): number => Math.ceil(bytes / 1024);

export const isTooLargeSendError = (error: {errcode?: string; httpStatus?: number} | null | undefined): boolean =>
    error?.errcode === 'M_TOO_LARGE' || error?.httpStatus === 413;
